import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import "../../Styles/UserLogin.less";
import { Content } from "antd/lib/layout/layout";
import { LoadingOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Button, Checkbox, Form, Input, Layout, message } from "antd";
import { AuthService } from "./AuthService";
import { setAccessToken } from "../../Store/apiStore";
import { loginFailure, loginSuccess } from "../../Store/authStore";
import logo from "../../../images/WordLogo/HomeSight_blue_tag.svg";
import SessionStorage from "../../Constants/SessionStorage";
import { AppStorageKeys, MessageKeys } from "../../Constants/Constants";

const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);
const CLIENT_ID = ENV_VARS.CLIENT_ID;
const AUTH_PORT = ENV_VARS.AUTH_PORT;
const AUTH_URL = ENV_VARS.AUTH_URL;
const formLayout = {
  labelCol: {
    xs: 24,
    md: 9,
    lg: 7,
  },
  wrapperCol: {
    xs: 24,
    md: 15,
    lg: 17,
  },
};

export const LoginPage = (props) => {
  console.log("LoginPage props", props);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [isLogging, setIsLogging] = useState(false);
  const { serviceProviderApi } = useSelector((state) => state.apis);

  let currentUser = useSelector((state) => state.auth.currentUser);

  useEffect(() => {
    message.destroy(MessageKeys.apiError);
    const queryParams = new URLSearchParams(window.location.search);
    const path = queryParams.get("path") || "";
    const access_token = queryParams.get("tok");
    const providerId = queryParams.get("prov");
    const partner = queryParams.get("part");
    const username = queryParams.get("user");
    const appEnv = queryParams.get("env");
    const providerType = queryParams.get("provtype");
    if (username && providerId && access_token) {
      console.log("LoginPage in-app login...");
      const roles = getUserRoles(access_token);
      appEnv && SessionStorage.set(AppStorageKeys.appEnv, appEnv);
      currentUser = {
        access_token,
        partner,
        providerId,
        providerType,
        username,
        roles,
      };
      dispatch(loginSuccess({ userInfo: currentUser }));
      dispatch(setAccessToken(access_token));
      props.history.push("/" + path);
      return;
    }
    if (currentUser) {
      console.log("LoginPage logged in...");
      props.history.push("/");
    }
  }, [currentUser]);

  const getUserRoles = (accessToken) => {
    const decoded = jwt_decode(accessToken);
    return decoded?.resource_access[CLIENT_ID]?.roles;
  };

  const onLogin = async (values) => {
    if (isLogging) return;
    setIsLogging(true);
    // console.log("onLogin:", values);
    const { username, password, partner } = values;
    const { protocol, hostname } = window.location;
    const authUrl = protocol + "//" + hostname;
    try {
      const loginRes = await AuthService.login(
        authUrl,
        username,
        password,
        partner
      );
      console.log("loginRes:", loginRes);
      if (loginRes.code === 200) {
        const userInfo = loginRes.message;
        userInfo.username = username;
        userInfo.partner = partner;
        console.log("Login success:", userInfo);
        checkProvider(partner, userInfo);
      } else {
        setIsLogging(false);
        dispatch(loginFailure());
        form.setFields([
          {
            name: "password",
            value: password,
            errors: [loginRes.message],
          },
        ]);
      }
    } catch (error) {
      setIsLogging(false);
      dispatch(loginFailure());
      console.log("Login error:", error);
      message.error("Error authenticating user. Please try again.");
    }
  };

  async function checkProvider(provider, userInfo) {
    console.log("checkProvider", provider, userInfo);
    try {
      dispatch(setAccessToken(userInfo.access_token));
      serviceProviderApi.getServiceproviderByName(
        provider,
        (error, data, _) => {
          console.log("checkProvider cb", data, error);
          setIsLogging(false);
          if (error) {
            dispatch(loginFailure());
            message.error("Error checking Partner. Please try again.");
          } else {
            const { providerid,providertype } = data?.serviceProvider || {};
            if (providerid) {
              const roles = getUserRoles(userInfo?.access_token);
              userInfo.roles = roles || [];
              userInfo.providerId = providerid;
              userInfo.providerType = providertype
              dispatch(loginSuccess({ userInfo }));
              message.success(
                `Welcome ${userInfo.partner}/${userInfo.username}!`
              );
            } else {
              dispatch(loginFailure());
              form.setFields([
                {
                  name: "partner",
                  value: provider,
                  errors: ["Partner not registered!"],
                },
              ]);
            }
          }
        }
      );
    } catch (error) {
      setIsLogging(false);
      dispatch(loginFailure());
      message.error("Error fetching Provider");
      console.log("Error fetching Provider", error);
    }
  }

  return (
    <Layout className="login-page-layout">
      <Content className="login-page-container">
        <div className="logo-main-content">
          <div className="logo-container">
            <div style={{ margin: "auto", width: "65%" }}>
              <div className="site-logo">
                <img className="full-logo" alt="HomeSight" src={logo} />
              </div>
              {/* <div className="site-tagline">Connected Care Redefined</div> */}
            </div>
          </div>
        </div>
        <div className="login-form-sider">
          <Form
            form={form}
            name="normal_login"
            className="login-form"
            onFinish={onLogin}
            requiredMark={false}
            {...formLayout}
          >
            <div className="login-form-items-container">
            <div className="side-tagline">Partner Portal</div>
              <>
                <Form.Item
                  name="username"
                  label="username"
                  rules={[
                    {
                      required: true,
                      message: "username required..!",
                    },
                  ]}
                >
                  <Input size="small" placeholder="Enter User Name" />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="password"
                  rules={[
                    {
                      required: true,
                      message: "password required..!",
                    },
                  ]}
                >
                  <Input
                    type="password"
                    size="small"
                    placeholder="Enter Password"
                  />
                </Form.Item>
              </>

              <Form.Item
                name="partner"
                label="partner"
                rules={[
                  {
                    required: true,
                    message: "partner name required..!",
                  },
                ]}
              >
                <Input
                  size="small"
                  placeholder="Enter Partner Name"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                />
              </Form.Item>
              <Form.Item className="form-login-button">
                <Button
                  size="small"
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  icon={isLogging && <LoadingOutlined />}
                >
                  {isLogging ? "Logging in..." : "Log in"}
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </Content>
    </Layout>
  );
};
